export const TELE_COUNSELLING_MODALITY_CODE = "T"
export const VIDEO_COUNSELLING_MODALITY_CODE = "V"
export const IN_PERSON_COUNSELLING_MODALITY_CODE = "FF"
export const IN_PERSON = "INPERSON"
export const IN_PERSON_SPACED = "IN PERSON"
export const TELEPHONIC = "TELEPHONIC"
export const ONLINE = "ONLINE"
export const VIRTUAL = "VIRTUAL"
export const VIDEO_COUNSELLING = "VIDEO-COUNSELLING"
export const TELE_COUNSELLING = "TELE-COUNSELLING"
export const VIDEO = "VIDEO"
